
(()=>{const ready=f=>document.readyState==='loading'?document.addEventListener('DOMContentLoaded',f):f();ready(()=>{
const mb=document.querySelector('[data-menu]'),mob=document.querySelector('[data-mobile]');mb?.addEventListener('click',()=>mob?.classList.toggle('open'));
document.querySelectorAll('[data-calculator]').forEach(initCalc);document.querySelectorAll('[data-tracking]').forEach(initTrack);document.querySelectorAll('[data-date-picker]').forEach(initDatePicker);
});
function initCalc(root){
const q=s=>root.querySelector(s),token=(root.dataset.token||'').trim(),rate=Number(root.dataset.rate||10),minimum=Number(root.dataset.minimum||750);
const from=q('[data-from]'),to=q('[data-to]'),btn=q('[data-calc]'),err=q('[data-error]'),result=q('[data-result]'),open=q('[data-open]'),contact=q('[data-contact]'),mapStatus=q('[data-mapstatus]'),mapHelp=q('[data-maphelp]');
let map,startM,endM,last;
function help(msg){mapHelp.textContent=msg;mapHelp.classList.add('show');mapStatus.textContent='MAP ERROR'}
async function ensureMap(){
if(map)return map;if(!token)throw new Error('Mapbox token mangler. Indsæt et public token under Theme settings → Klinker system.');
if(!window.mapboxgl)throw new Error('Mapbox GL JS kunne ikke indlæses.');
mapboxgl.accessToken=token;map=new mapboxgl.Map({container:q('[data-map]'),style:'mapbox://styles/mapbox/dark-v11',center:[10.1,56.1],zoom:5.3,attributionControl:true});
return await new Promise((resolve,reject)=>{map.once('load',()=>{map.resize();mapStatus.textContent='MAP READY';resolve(map)});map.once('error',e=>reject(e.error||new Error('Mapbox style/token error')))});
}
async function requestJson(url,label){
const r=await fetch(url);if(!r.ok){let detail='';try{detail=(await r.text()).slice(0,180)}catch(e){};throw new Error(`${label}: HTTP ${r.status}${detail?' — '+detail:''}`)}return r.json();
}
async function geocode(text){
const u=`https://api.mapbox.com/search/geocode/v6/forward?q=${encodeURIComponent(text)}&country=dk&limit=1&access_token=${encodeURIComponent(token)}`;
const d=await requestJson(u,'Adresseopslag fejlede');if(!d.features?.length)throw new Error(`Kunne ikke finde "${text}".`);
const f=d.features[0];return{coords:f.geometry.coordinates,name:f.properties?.full_address||f.properties?.name||text};
}
async function directions(a,b){
const c=`${a[0]},${a[1]};${b[0]},${b[1]}`,u=`https://api.mapbox.com/directions/v5/mapbox/driving/${c}?exclude=ferry&geometries=geojson&overview=full&steps=false&access_token=${encodeURIComponent(token)}`;
const d=await requestJson(u,'Ruteberegning fejlede');if(!d.routes?.length)throw new Error('Ingen vej-/brorute fundet uden færge.');return d.routes[0];
}
function marker(f){const e=document.createElement('div');Object.assign(e.style,{width:'17px',height:'17px',borderRadius:'50%',border:'2px solid #67E8F9',background:f?'#67E8F9':'#050B14',boxShadow:'0 0 0 7px rgba(103,232,249,.08)'});return e}
async function draw(g,a,b,an,bn){await ensureMap();const ft={type:'Feature',properties:{},geometry:g};if(map.getSource('route'))map.getSource('route').setData(ft);else{map.addSource('route',{type:'geojson',data:ft});map.addLayer({id:'routeGlow',type:'line',source:'route',paint:{'line-color':'#67E8F9','line-width':9,'line-opacity':.12}});map.addLayer({id:'routeLine',type:'line',source:'route',paint:{'line-color':'#67E8F9','line-width':3.2,'line-opacity':.98}})}startM?.remove();endM?.remove();startM=new mapboxgl.Marker({element:marker(false)}).setLngLat(a).addTo(map);endM=new mapboxgl.Marker({element:marker(true)}).setLngLat(b).addTo(map);const bd=new mapboxgl.LngLatBounds();g.coordinates.forEach(c=>bd.extend(c));map.fitBounds(bd,{padding:Math.min(90,innerWidth*.08),duration:900});mapStatus.textContent='ROUTE READY'}
function hidden(){if(!last)return;const vals={'[data-hid-id]':last.id,'[data-hid-from]':last.a.name,'[data-hid-to]':last.b.name,'[data-hid-km]':last.km.toFixed(1)+' KM','[data-hid-price]':Math.round(last.price)+' KR.'};Object.entries(vals).forEach(([s,v])=>{const e=q(s);if(e)e.value=v});q('[data-summary]').innerHTML=`<strong style="color:#F5F4EF">${last.id}</strong><br>${last.a.name}<br>→ ${last.b.name}<br><br>${last.km.toLocaleString('da-DK',{maximumFractionDigits:1})} KM / ${Math.round(last.price).toLocaleString('da-DK')} KR.`}
async function calc(){err.textContent='';mapHelp.classList.remove('show');if(!from.value.trim()||!to.value.trim()){err.textContent='Indtast både afhentning og levering.';return}btn.disabled=true;const old=btn.innerHTML;btn.textContent='BEREGNER…';try{await ensureMap();const[a,b]=await Promise.all([geocode(from.value.trim()),geocode(to.value.trim())]);const r=await directions(a.coords,b.coords),km=r.distance/1000,p=Math.max(minimum,km*rate);last={a,b,km,price:p,id:'KL-'+String(Date.now()).slice(-6)};q('[data-route]').textContent=`${a.name.toUpperCase()} → ${b.name.toUpperCase()}`;q('[data-distance]').textContent=km.toLocaleString('da-DK',{maximumFractionDigits:1})+' KM';q('[data-price]').textContent=Math.round(p).toLocaleString('da-DK')+' KR.';q('[data-status]').textContent='ROUTE READY';result.classList.add('ready');open.disabled=false;hidden();await draw(r.geometry,a.coords,b.coords,a.name,b.name)}catch(e){console.error(e);err.textContent=e.message||'Der opstod en fejl.';help(e.message||'Mapbox fejl')}finally{btn.disabled=false;btn.innerHTML=old}}
btn?.addEventListener('click',calc);[from,to].forEach(e=>e?.addEventListener('keydown',x=>{if(x.key==='Enter')calc()}));open?.addEventListener('click',()=>{if(last){hidden();contact.classList.add('open');contact.scrollIntoView({behavior:'smooth'})}});
ensureMap().catch(e=>help(e.message||'Mapbox fejl'));
}
function initTrack(root){
const input=root.querySelector('[data-trackinput]'),btn=root.querySelector('[data-trackbtn]'),out=root.querySelector('[data-trackresult]'),err=root.querySelector('[data-trackerror]');
const dataNode=root.querySelector('[data-trackdata]');
let items=[];
try{
  items=JSON.parse(dataNode?.textContent||'[]');
  if(!Array.isArray(items))items=[];
}catch(e){
  console.error('Klinker tracking data error',e,dataNode?.textContent);
  items=[];
}
const normalize=v=>String(v??'').trim().toUpperCase().replace(/[^A-Z0-9]/g,'');
const displayRef=x=>{
  const raw=String(x?.reference||x?.handle||'').trim().toUpperCase();
  if(/^KL\d+$/.test(normalize(raw)))return 'KL-'+normalize(raw).slice(2);
  return raw||'—';
};
function run(pushUrl=true){
  err.textContent='';out.classList.remove('show');
  const ref=normalize(input.value);
  if(!ref){err.textContent='Indtast dit reference-nummer, fx KL-33453.';input.focus();return}
  const x=items.find(i=>normalize(i?.reference)===ref||normalize(i?.handle)===ref);
  if(!x){
    err.textContent='Vi kunne ikke finde reference-nummeret. Kontrollér nummeret og prøv igen.';
    console.warn('Klinker tracking lookup miss',{searched:ref,available:items.map(i=>({reference:i?.reference,handle:i?.handle}))});
    return;
  }
  const shownRef=displayRef(x);
  out.querySelector('[data-outref]').textContent=shownRef;
  out.querySelector('[data-outroute]').textContent=`${x.pickup||'—'} → ${x.destination||'—'}`;
  out.querySelector('[data-outstatus]').textContent=(x.status_label||x.status||'—').toUpperCase();
  out.querySelector('[data-outeta]').textContent=x.eta||'—';
  out.querySelector('[data-outupdated]').textContent=x.updated||'—';
  out.querySelector('[data-outvehicle]').textContent=x.vehicle||'—';
  out.querySelector('[data-outdocumentation]').textContent=x.documentation_status||'Ingen dokumentationsstatus registreret';
  const aliases={request:'requested',received:'requested',driverassigned:'assigned',chauffeurassigned:'assigned',assigned:'assigned',pickedup:'picked_up',picked:'picked_up',transit:'in_transit',intransit:'in_transit',complete:'delivered',completed:'delivered',delivered:'delivered',requested:'requested'};
  const statusKey=String(x.status||'').trim().toLowerCase().replace(/[^a-z0-9]/g,'');
  const status=aliases[statusKey]||String(x.status||'').trim().toLowerCase();
  const order=['requested','assigned','picked_up','in_transit','delivered'],ix=order.indexOf(status);
  out.querySelectorAll('[data-step]').forEach((e,i)=>e.classList.toggle('active',ix>=0&&i<=ix));
  out.classList.add('show');
  if(pushUrl&&history.replaceState){const u=new URL(location.href);u.searchParams.set('tracking',shownRef);history.replaceState({},'',u)}
  out.scrollIntoView({behavior:'smooth',block:'nearest'});
}
btn?.addEventListener('click',()=>run());
input?.addEventListener('keydown',e=>{if(e.key==='Enter')run()});
const param=new URLSearchParams(location.search).get('tracking');if(param){input.value=param;run(false)}
}

function initDatePicker(root){
  const display=root.querySelector('[data-date-display]');
  const calendar=root.querySelector('[data-calendar]');
  const grid=root.querySelector('[data-cal-grid]');
  const title=root.querySelector('[data-cal-title]');
  const prev=root.querySelector('[data-cal-prev]');
  const next=root.querySelector('[data-cal-next]');
  const hidden=root.querySelector('[data-date-hidden]');
  if(!display||!calendar||!grid||!title||!hidden)return;

  const today=new Date();
  today.setHours(0,0,0,0);
  let view=new Date(today.getFullYear(),today.getMonth(),1);
  let selected=null;

  const monthNames=['JANUAR','FEBRUAR','MARTS','APRIL','MAJ','JUNI','JULI','AUGUST','SEPTEMBER','OKTOBER','NOVEMBER','DECEMBER'];
  const pad=n=>String(n).padStart(2,'0');
  const iso=d=>`${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;
  const pretty=d=>`${pad(d.getDate())}.${pad(d.getMonth()+1)}.${d.getFullYear()}`;

  function render(){
    title.textContent=`${monthNames[view.getMonth()]} ${view.getFullYear()}`;
    grid.innerHTML='';
    const firstDay=(new Date(view.getFullYear(),view.getMonth(),1).getDay()+6)%7; // Monday-first
    const days=new Date(view.getFullYear(),view.getMonth()+1,0).getDate();

    for(let i=0;i<firstDay;i++){
      const empty=document.createElement('div');
      empty.className='k-cal-empty';
      grid.appendChild(empty);
    }
    for(let day=1;day<=days;day++){
      const d=new Date(view.getFullYear(),view.getMonth(),day);
      const b=document.createElement('button');
      b.type='button';
      b.className='k-cal-day';
      b.textContent=day;
      if(d<today)b.disabled=true;
      if(d.getTime()===today.getTime())b.classList.add('today');
      if(selected&&d.getTime()===selected.getTime())b.classList.add('selected');
      b.addEventListener('click',()=>{
        selected=d;
        hidden.value=iso(d);
        display.querySelector('[data-date-label]').textContent=pretty(d);
        calendar.classList.remove('open');
        render();
      });
      grid.appendChild(b);
    }
    const prevMonth=new Date(view.getFullYear(),view.getMonth()-1,1);
    prev.disabled=prevMonth < new Date(today.getFullYear(),today.getMonth(),1);
  }

  display.addEventListener('click',()=>calendar.classList.toggle('open'));
  prev.addEventListener('click',()=>{view=new Date(view.getFullYear(),view.getMonth()-1,1);render()});
  next.addEventListener('click',()=>{view=new Date(view.getFullYear(),view.getMonth()+1,1);render()});
  document.addEventListener('click',e=>{if(!root.contains(e.target))calendar.classList.remove('open')});
  render();
}

})();
